import HttpResponse from "../../../../../utils/http/http.response";

export enum TaxiCorporationOrderBillingsListResponseDataItemBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export enum TaxiCorporationOrderBillingsListResponseDataItemBillingType {
  PUB_RAILY_2_TAXI = "PUB_RAILY_2_TAXI",
  PRIV_CARGO_2_TAXI = "PRIV_CARGO_2_TAXI",
  PRIV_TAXI_2_RAILY = "PRIV_TAXI_2_RAILY",
}

export type TaxiCorporationOrderBillingsListResponseDataItem = {
  id: string;
  date: string;
  humanId: string;
  planEntryHumanIds: number[];
  externalId: string | null;
  status: string | null;
  cargoCompany: string;
  distance: number;
  amountForDistance: number;
  baseDistanceRate: number;
  amountForChargeHaltings: number | null;
  amountForChargeHighways: number | null;
  allContributionsAmount: number;
  sumOfDiscounts: number | null;
  billingType: TaxiCorporationOrderBillingsListResponseDataItemBillingType;
  billingModel: TaxiCorporationOrderBillingsListResponseDataItemBillingModel;
  passengers: string[];
  responsibleTaxi: string | null;
};

export type TaxiCorporationOrderBillingsListResponseDataStats = {
  distance: number;
  sumOfDiscounts: number;
  amountForChargeHaltings: number;
  amountForChargeHighways: number;
  amountForDistance: number;
  allContributionsAmount: number;
};

export type TaxiCorporationOrderBillingsListResponseData = {
  data: TaxiCorporationOrderBillingsListResponseDataItem[];
  totalCount: number;
  stats: TaxiCorporationOrderBillingsListResponseDataStats;
};

type TaxiCorporationOrderBillingsListResponse =
  HttpResponse<TaxiCorporationOrderBillingsListResponseData>;

export default TaxiCorporationOrderBillingsListResponse;
